import { render, staticRenderFns } from "./COP.vue?vue&type=template&id=ea6837b6&scoped=true"
import script from "./COP.vue?vue&type=script&lang=js"
export * from "./COP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6837b6",
  null
  
)

export default component.exports